import { Authorization, Token, UserInfo } from '@/constants/authorization';
import { getSearchValue } from './common-util';
const KeySet = [Authorization, Token, UserInfo];
const logoutPreparations = new Set<() => Promise<void>>();
export function registerLogoutPreparation(prepare: () => Promise<void>) {
  logoutPreparations.add(prepare);
  return () => {
    logoutPreparations.delete(prepare);
  };
}
export async function prepareForLogout() {
  for (const prepare of logoutPreparations) await prepare();
}

const storage = {
  getAuthorization: () => {
    return localStorage.getItem(Authorization);
  },
  getToken: () => {
    return localStorage.getItem(Token);
  },
  getUserInfo: () => {
    return localStorage.getItem(UserInfo);
  },
  getUserInfoObject: () => {
    return JSON.parse(localStorage.getItem(UserInfo) || '');
  },
  setAuthorization: (value: string) => {
    localStorage.setItem(Authorization, value);
  },
  setToken: (value: string) => {
    localStorage.setItem(Token, value);
  },
  setUserInfo: (value: string | Record<string, unknown>) => {
    let valueStr = typeof value !== 'string' ? JSON.stringify(value) : value;
    localStorage.setItem(UserInfo, valueStr);
  },
  setItems: (pairs: Record<string, string>) => {
    Object.entries(pairs).forEach(([key, value]) => {
      localStorage.setItem(key, value);
    });
  },
  removeAuthorization: () => {
    localStorage.removeItem(Authorization);
    window.dispatchEvent(new Event('capture-logout'));
  },
  removeAll: () => {
    window.dispatchEvent(new Event('capture-logout'));
    KeySet.forEach((x) => {
      localStorage.removeItem(x);
    });
  },
  setLanguage: (lng: string) => {
    localStorage.setItem('lng', lng);
  },
  getLanguage: (): string => {
    return localStorage.getItem('lng') as string;
  },
};

export const getAuthorization = () => {
  const auth = getSearchValue('auth');
  const authorization = auth
    ? 'Bearer ' + auth
    : storage.getAuthorization() || '';

  return authorization;
};

export const getAuthorizedRequestHeaders = (): Record<string, string> => {
  const authorization = getAuthorization();
  const sharedDialogId = getSearchValue('shared_id');
  return {
    ...(authorization ? { Authorization: authorization } : {}),
    ...(sharedDialogId ? { 'X-Dialog-ID': sharedDialogId } : {}),
  };
};

export default storage;

// Will not jump to the login page
export function redirectToLogin() {
  const baseUrl = process.env.BASE_URL || '';
  window.location.href = `${location.origin}${baseUrl}/login`;
}
